import { client } from 'lib/util/client'
import Link from 'next/link'
import { useEffect, useState } from 'react'
import { z } from 'zod'

import { articleReferenceSchema } from '@/lib/zodSchemas/portableTextFieldSchema'

export type ArticleReferenceType = z.infer<typeof articleReferenceSchema>

export function ArticleReference({ value }: { value: ArticleReferenceType }) {
  const [topic, setTopic] = useState<string>()

  useEffect(() => {
    client
      .fetch(`*[_type == "topic" && references("${value._ref}")]`)
      .then((res) => {
        setTopic(res[0].slug.current)
      })
  }, [value, setTopic])

  const slug = value.articleSlug?.current || ''
  if (slug === '') {
    console.error("ArticleReference's slug is empty", value)
  }
  const href = `/advice/${slug}`
  return (
    <Link href={href} className="text-green-600 hover:text-green-800 underline">
      {value.articleTitle}
    </Link>
  )
}
